const ShipmentTypes = {
  GET_SHIPMENT_LIST_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENT_LIST_PROGRESS',
  GET_SHIPMENT_LIST_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENT_LIST_SUCCESS',
  GET_SHIPMENT_LIST_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENT_LIST_ERROR',
  SET_SHIPMENT_LIST: 'SHIPMENT_TYPE.SET_SHIPMENT_LIST',
  REFRESH_SHIPMENT_LIST_PROGRESS: 'SHIPMENT_TYPE.REFRESH_SHIPMENT_LIST_PROGRESS',
  REFRESH_SHIPMENT_LIST_SUCCESS: 'SHIPMENT_TYPE.REFRESH_SHIPMENT_LIST_SUCCESS',
  REFRESH_SHIPMENT_LIST_ERROR: 'SHIPMENT_TYPE.REFRESH_SHIPMENT_LIST_ERROR',
  GET_SHIPMENT_DETAILS_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENT_DETAILS_PROGRESS',
  GET_SHIPMENT_DETAILS_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENT_DETAILS_SUCCESS',
  GET_SHIPMENT_DETAILS_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENT_DETAILS_ERROR',
  SET_SHIPMENT_FILTERS: 'SHIPMENT_TYPE.SET_SHIPMENT_FILTERS',
  SET_SEARCH_QUOTE_FILTERS: 'SHIPMENT_TYPE.SET_SEARCH_QUOTE_FILTERS',
  GET_SHIPMENT_DASHBOARD_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENT_DASHBOARD_PROGRESS',
  GET_SHIPMENT_DASHBOARD_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENT_DASHBOARD_SUCCESS',
  GET_SHIPMENT_DASHBOARD_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENT_DASHBOARD_ERROR',
  SET_SHIPMEN_DETAILS: 'SHIPMENT_TYPE.SET_SHIPMEN_DETAILS',
  SET_SHIPMEN_EDIT_STATUS: 'SHIPMENT_TYPE.SET_SHIPMEN_EDIT_STATUS',
  GENERATE_SHIPMENT_NUMBER_PROGRESS: 'SHIPMENT_TYPE.GENERATE_SHIPMENT_NUMBER_PROGRESS',
  GENERATE_SHIPMENT_NUMBER_SUCCESS: 'SHIPMENT_TYPE.GENERATE_SHIPMENT_NUMBER_SUCCESS',
  GENERATE_SHIPMENT_NUMBER_ERROR: 'SHIPMENT_TYPE.GENERATE_SHIPMENT_NUMBER_ERROR',
  SET_SELECTED_SHIPMENTS: 'SHIPMENT_TYPE.SET_SELECTED_SHIPMENTS',
  DELETE_SHIPMENTS_PROGRESS: 'SHIPMENT_TYPE.DELETE_SHIPMENTS_PROGRESS',
  COPY_SHIPMENTS_PROGRESS: 'SHIPMENT_TYPE.COPY_SHIPMENTS_PROGRESS',
  COPY_SHIPMENTS_SUCCESS: 'SHIPMENT_TYPE.COPY_SHIPMENTS_SUCCESS',
  COPY_SHIPMENTS_ERROR: 'SHIPMENT_TYPE.COPY_SHIPMENTS_ERROR',
  CONSOLIDATE_SHIPMENTS_PROGRESS: 'SHIPMENT_TYPE.CONSOLIDATE_SHIPMENTS_PROGRESS',
  CONSOLIDATE_SHIPMENTS_SUCCESS: 'SHIPMENT_TYPE.CONSOLIDATE_SHIPMENTS_SUCCESS',
  CONSOLIDATE_SHIPMENTS_ERROR: 'SHIPMENT_TYPE.CONSOLIDATE_SHIPMENTS_ERROR',
  CREATE_SHIPMENT_PROGRESS: 'SHIPMENT_TYPE.CREATE_SHIPMENT_PROGRESS',
  CREATE_SHIPMENT_SUCCESS: 'SHIPMENT_TYPE.CREATE_SHIPMENT_SUCCESS',
  CREATE_SHIPMENT_ERROR: 'SHIPMENT_TYPE.CREATE_SHIPMENT_ERROR',
  SHIPMENT_SPOTBID_PROGRESS: 'SHIPMENT_TYPE.SHIPMENT_SPOTBID_PROGRESS',
  SHIPMENT_SPOTBID_SUCCESS: 'SHIPMENT_TYPE.SHIPMENT_SPOTBID_SUCCESS',
  SHIPMENT_SPOTBID_ERROR: 'SHIPMENT_TYPE.SHIPMENT_SPOTBID_ERROR',

  SHIPMENT_ADD_BIDDER_PROGRESS: 'SHIPMENT_TYPE.SHIPMENT_ADD_BIDDER_PROGRESS',
  SHIPMENT_ADD_BIDDER_SUCCESS: 'SHIPMENT_TYPE.SHIPMENT_ADD_BIDDER_SUCCESS',
  SHIPMENT_ADD_BIDDER_ERROR: 'SHIPMENT_TYPE.SHIPMENT_ADD_BIDDER_ERROR',

  GET_RATE_SHOP_LIST_PROGRESS: 'SHIPMENT_TYPE.GET_RATE_SHOP_LIST_PROGRESS',
  GET_RATE_SHOP_LIST_SUCCESS: 'SHIPMENT_TYPE.GET_RATE_SHOP_LIST_SUCCESS',
  GET_RATE_SHOP_LIST_ERROR: 'SHIPMENT_TYPE.GET_RATE_SHOP_LIST_ERROR',
  RESET_RATE_SHOP_LIST: 'SHIPMENT_TYPE.RESET_RATE_SHOP_LIST',
  END_SPOT_BID_PROGRESS: 'SHIPMENT_TYPE.END_SPOT_BID_PROGRESS',
  END_SPOT_BID_SUCCESS: 'SHIPMENT_TYPE.END_SPOT_BID_SUCCESS',
  END_SPOT_BID_ERROR: 'SHIPMENT_TYPE.END_SPOT_BID_ERROR',
  GET_DOCUMENTS_PROGRESS: 'SHIPMENT_TYPE.GET_DOCUMENTS_PROGRESS',
  GET_DOCUMENTS_SUCCESS: 'SHIPMENT_TYPE.GET_DOCUMENTS_SUCCESS',
  GET_DOCUMENTS_ERROR: 'SHIPMENT_TYPE.GET_DOCUMENTS_ERROR',
  GET_DEFAULT_ACCESSORIALS_PROGRESS: 'SHIPMENT_TYPE.GET_DEFAULT_ACCESSORIALS_PROGRESS',
  GET_DEFAULT_ACCESSORIALS_SUCCESS: 'SHIPMENT_TYPE.GET_DEFAULT_ACCESSORIALS_SUCCESS',
  GET_DEFAULT_ACCESSORIALS_ERROR: 'SHIPMENT_TYPE.GET_DEFAULT_ACCESSORIALS_ERROR',

  GET_TENDER_EMAIL_PROGRESS: 'SHIPMENT_TYPE.GET_TENDER_EMAIL_PROGRESS',
  GET_TENDER_EMAIL_SUCCESS: 'SHIPMENT_TYPE.GET_TENDER_EMAIL_SUCCESS',
  GET_TENDER_EMAIL_ERROR: 'SHIPMENT_TYPE.GET_TENDER_EMAIL_ERROR',

  TENDER_PROCESS_PROGRESS: 'SHIPMENT_TYPE.TENDER_PROCESS_PROGRESS',
  TENDER_PROCESS_SUCCESS: 'SHIPMENT_TYPE.TENDER_PROCESS_SUCCESS',
  TENDER_PROCESS_ERROR: 'SHIPMENT_TYPE.TENDER_PROCESS_ERROR',

  GET_SPOT_BID_DATA_PROGRESS: 'SHIPMENT_TYPE.GET_SPOT_BID_DATA_PROGRESS',
  GET_SPOT_BID_DATA_SUCCESS: 'SHIPMENT_TYPE.GET_SPOT_BID_DATA_SUCCESS',
  GET_SPOT_BID_DATA_ERROR: 'SHIPMENT_TYPE.GET_SPOT_BID_DATA_ERROR',

  SHIPMENT_PARTIAL_SAVE: 'SHIPMENT_TYPE.SHIPMENT_PARTIAL_SAVE',

  SET_SHIPMENT_DATA: 'SHIPMENT_TYPE.SET_SHIPMENT_DATA',

  MILEAGE_CALCULATOR_PROGRESS: 'SHIPMENT_TYPE.MILEAGE_CALCULATOR_PROGRESS',
  MILEAGE_CALCULATOR_SUCCESS: 'SHIPMENT_TYPE.MILEAGE_CALCULATOR_SUCCESS',
  MILEAGE_CALCULATOR_ERROR: 'SHIPMENT_TYPE.MILEAGE_CALCULATOR_ERROR',

  GET_CUSTOMER_ROUTINGS_SETTINGS_PROGRESS: 'SHIPMENT_TYPE.GET_CUSTOMER_ROUTINGS_SETTINGS_PROGRESS',
  GET_CUSTOMER_ROUTINGS_SETTINGS_SUCCESS: 'SHIPMENT_TYPE.GET_CUSTOMER_ROUTINGS_SETTINGS_SUCCESS',
  GET_CUSTOMER_ROUTINGS_SETTINGS_ERROR: 'SHIPMENT_TYPE.GET_CUSTOMER_ROUTINGS_SETTINGS_ERROR',

  SET_SHIPMENT_DETAILS_ACTIVE_TAB: 'SHIPMENT_TYPE.SET_SHIPMENT_DETAILS_ACTIVE_TAB',

  SAVE_ADDRESS_BOOK_PROGRESS: 'SHIPMENT_TYPE.SAVE_ADDRESS_BOOK_PROGRESS',
  SAVE_ADDRESS_BOOK_SUCCESS: 'SHIPMENT_TYPE.SAVE_ADDRESS_BOOK_SUCCESS',
  SAVE_ADDRESS_BOOK_ERROR: 'SHIPMENT_TYPE.SAVE_ADDRESS_BOOK_ERROR',

  DELETE_ADDRESS_BOOK_PROGRESS: 'SHIPMENT_TYPE.DELETE_ADDRESS_BOOK_PROGRESS',
  DELETE_ADDRESS_BOOK_SUCCESS: 'SHIPMENT_TYPE.DELETE_ADDRESS_BOOK_SUCCESS',
  DELETE_ADDRESS_BOOK_ERROR: 'SHIPMENT_TYPE.DELETE_ADDRESS_BOOK_ERROR',

  SAVE_PRODUCT_PROGRESS: 'SHIPMENT_TYPE.SAVE_PRODUCT_PROGRESS',
  SAVE_PRODUCT_SUCCESS: 'SHIPMENT_TYPE.SAVE_PRODUCT_SUCCESS',
  SAVE_PRODUCT_ERROR: 'SHIPMENT_TYPE.SAVE_PRODUCT_ERROR',

  GET_TRACKING_DETAILS_PROGRESS: 'SHIPMENT_TYPE.GET_TRACKING_DETAILS_PROGRESS',
  GET_TRACKING_DETAILS_SUCCESS: 'SHIPMENT_TYPE.GET_TRACKING_DETAILS_SUCCESS',
  GET_TRACKING_DETAILS_ERROR: 'SHIPMENT_TYPE.GET_TRACKING_DETAILS_ERROR',

  SEND_DOCUMENT_MAIL_PROGRESS: 'SHIPMENT_TYPE.SEND_DOCUMENT_MAIL_PROGRESS',
  SEND_DOCUMENT_MAIL_SUCCESS: 'SHIPMENT_TYPE.SEND_DOCUMENT_MAIL_SUCCESS',
  SEND_DOCUMENT_MAIL_ERROR: 'SHIPMENT_TYPE.SEND_DOCUMENT_MAIL_ERROR',

  SAVE_SHIPMENT_ITRACK_PROGRESS: 'SHIPMENT_TYPE.SAVE_SHIPMENT_ITRACK_PROGRESS',
  SAVE_SHIPMENT_ITRACK_SUCCESS: 'SHIPMENT_TYPE.SAVE_SHIPMENT_ITRACK_SUCCESS',
  SAVE_SHIPMENT_ITRACK_ERROR: 'SHIPMENT_TYPE.SAVE_SHIPMENT_ITRACK_ERROR',

  GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_PROGRESS',
  GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_SUCCESS',
  GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENT_NOTIFICATION_DISTRIBUTORS_ERROR',

  GET_SHIPMENT_NOTIFICATION_ROUTING_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENT_NOTIFICATION_ROUTING_PROGRESS',
  GET_SHIPMENT_NOTIFICATION_ROUTING_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENT_NOTIFICATION_ROUTING_SUCCESS',
  GET_SHIPMENT_NOTIFICATION_ROUTING_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENT_NOTIFICATION_ROUTING_ERROR',

  SAVE_NOTIFICATION_DISTRIBUTORS_PROGRESS: 'SHIPMENT_TYPE.SAVE_NOTIFICATION_DISTRIBUTORS_PROGRESS',
  SAVE_NOTIFICATION_DISTRIBUTORS_SUCCESS: 'SHIPMENT_TYPE.SAVE_NOTIFICATION_DISTRIBUTORS_SUCCESS',
  SAVE_NOTIFICATION_DISTRIBUTORS_ERROR: 'SHIPMENT_TYPE.SAVE_NOTIFICATION_DISTRIBUTORS_ERROR',

  DELETE_NOTIFICATION_DISTRIBUTORS_PROGRESS: 'SHIPMENT_TYPE.DELETE_NOTIFICATION_DISTRIBUTORS_PROGRESS',
  DELETE_NOTIFICATION_DISTRIBUTORS_SUCCESS: 'SHIPMENT_TYPE.DELETE_NOTIFICATION_DISTRIBUTORS_SUCCESS',
  DELETE_NOTIFICATION_DISTRIBUTORS_ERROR: 'SHIPMENT_TYPE.DELETE_NOTIFICATION_DISTRIBUTORS_ERROR',

  SAVE_NOTIFICATION_ROUTING_PROGRESS: 'SHIPMENT_TYPE.SAVE_NOTIFICATION_ROUTING_PROGRESS',
  SAVE_NOTIFICATION_ROUTING_SUCCESS: 'SHIPMENT_TYPE.SAVE_NOTIFICATION_ROUTING_SUCCESS',
  SAVE_NOTIFICATION_ROUTING_ERROR: 'SHIPMENT_TYPE.SAVE_NOTIFICATION_ROUTING_ERROR',

  DELETE_NOTIFICATION_ROUTING_PROGRESS: 'SHIPMENT_TYPE.DELETE_NOTIFICATION_ROUTING_PROGRESS',
  DELETE_NOTIFICATION_ROUTING_SUCCESS: 'SHIPMENT_TYPE.DELETE_NOTIFICATION_ROUTING_SUCCESS',
  DELETE_NOTIFICATION_ROUTING_ERROR: 'SHIPMENT_TYPE.DELETE_NOTIFICATION_ROUTING_ERROR',

  SET_SHIPMENT_ADDRESS_BOOK_FILTER: 'SHIPMENT_TYPE.SET_SHIPMENT_ADDRESS_BOOK_FILTER',

  SEARCH_CUSTOMER_ADDRESS_BOOK_PROGRESS: 'SHIPMENT_TYPE.SEARCH_CUSTOMER_ADDRESS_BOOK_PROGRESS',
  SEARCH_CUSTOMER_ADDRESS_BOOK_SUCCESS: 'SHIPMENT_TYPE.SEARCH_CUSTOMER_ADDRESS_BOOK_SUCCESS',
  UPDATE_CUSTOMER_ADDRESS_BOOK: 'SHIPMENT_TYPE.UPDATE_CUSTOMER_ADDRESS_BOOK',
  SEARCH_CUSTOMER_ADDRESS_BOOK_ERROR: 'SHIPMENT_TYPE.SEARCH_CUSTOMER_ADDRESS_BOOK_ERROR',
  SET_CUSTOMER_ADDRESS_BOOK: 'SHIPMENT_TYPE.SET_CUSTOMER_ADDRESS_BOOK',

  GET_SHIPMENT_CUSTOMER_ACCESSORIALS_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENT_CUSTOMER_ACCESSORIALS_PROGRESS',
  GET_SHIPMENT_CUSTOMER_ACCESSORIALS_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENT_CUSTOMER_ACCESSORIALS_SUCCESS',
  GET_SHIPMENT_CUSTOMER_ACCESSORIALS_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENT_CUSTOMER_ACCESSORIALS_ERROR',

  CREATE_SHIPMENT_QUOTE_PROGRESS: 'SHIPMENT_TYPE.CREATE_SHIPMENT_QUOTE_PROGRESS',
  CREATE_SHIPMENT_QUOTE_SUCCESS: 'SHIPMENT_TYPE.CREATE_SHIPMENT_QUOTE_SUCCESS',
  CREATE_SHIPMENT_QUOTE_ERROR: 'SHIPMENT_TYPE.CREATE_SHIPMENT_QUOTE_ERROR',
  RESET_CREATE_SHIPMENT_QUOTE: 'SHIPMENT_TYPE.RESET_CREATE_SHIPMENT_QUOTE',

  SAVE_SHIPMENT_ACCOUNTING_PARTIAL_PROGRESS: 'SHIPMENT_TYPE.SAVE_SHIPMENT_ACCOUNTING_PARTIAL_PROGRESS',
  SAVE_SHIPMENT_ACCOUNTING_PARTIAL_SUCCESS: 'SHIPMENT_TYPE.SAVE_SHIPMENT_ACCOUNTING_PARTIAL_SUCCESS',
  SAVE_SHIPMENT_ACCOUNTING_PARTIAL_ERROR: 'SHIPMENT_TYPE.SAVE_SHIPMENT_ACCOUNTING_PARTIAL_ERROR',

  CREATE_SHIPMENT_FROM_QUOTE_PROGRESS: 'SHIPMENT_TYPE.CREATE_SHIPMENT_FROM_QUOTE_PROGRESS',
  CREATE_SHIPMENT_FROM_QUOTE_SUCCESS: 'SHIPMENT_TYPE.CREATE_SHIPMENT_FROM_QUOTE_SUCCESS',
  CREATE_SHIPMENT_FROM_QUOTE_ERROR: 'SHIPMENT_TYPE.CREATE_SHIPMENT_FROM_QUOTE_ERROR',

  GET_MILAGE_BY_STOPS_PROGRESS: 'SHIPMENT_TYPE.GET_MILAGE_BY_STOPS_PROGRESS',
  GET_MILAGE_BY_STOPS_SUCCESS: 'SHIPMENT_TYPE.GET_MILAGE_BY_STOPS_SUCCESS',
  GET_MILAGE_BY_STOPS_ERROR: 'SHIPMENT_TYPE.GET_MILAGE_BY_STOPS_ERROR',

  GET_PARCEL_EXPRESS_RATES_PROGRESS: 'SHIPMENT_TYPE.GET_PARCEL_EXPRESS_RATES_PROGRESS',
  GET_PARCEL_EXPRESS_RATES_SUCCESS: 'SHIPMENT_TYPE.GET_PARCEL_EXPRESS_RATES_SUCCESS',
  GET_PARCEL_EXPRESS_RATES_ERROR: 'SHIPMENT_TYPE.GET_PARCEL_EXPRESS_RATES_ERROR',

  CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_PROGRESS: 'CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_PROGRESS',
  CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_SUCCESS: 'CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_SUCCESS',
  CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_ERROR: 'CREATE_PARCEL_EXPRESS_SHIPPING_LABEL_ERROR',
  RESET_CREATE_PARCEL_EXPRESS_SHIPPING_LABEL: 'RESET_CREATE_PARCEL_EXPRESS_SHIPPING_LABEL',

  GENERATE_APPROVAL_NUMBER_PROGRESS: 'SHIPMENT_TYPE.GENERATE_APPROVAL_NUMBER_PROGRESS',
  GENERATE_APPROVAL_NUMBER_SUCCESS: 'SHIPMENT_TYPE.GENERATE_APPROVAL_NUMBER_SUCCESS',
  GENERATE_APPROVAL_NUMBER_ERROR: 'SHIPMENT_TYPE.GENERATE_APPROVAL_NUMBER_ERROR',

  VALIDATE_AND_GET_APPROVERS_LIST_PROGRESS: 'SHIPMENT_TYPE.VALIDATE_AND_GET_APPROVERS_LIST_PROGRESS',
  VALIDATE_AND_GET_APPROVERS_LIST_SUCCESS: 'SHIPMENT_TYPE.VALIDATE_AND_GET_APPROVERS_LIST_SUCCESS',
  VALIDATE_AND_GET_APPROVERS_LIST_ERROR: 'SHIPMENT_TYPE.VALIDATE_AND_GET_APPROVERS_LIST_ERROR',

  CREATE_CHILD_SHIPMENT_PROGRESS: 'SHIPMENT_TYPE.CREATE_CHILD_SHIPMENT_PROGRESS',
  CREATE_CHILD_SHIPMENT_SUCCESS: 'SHIPMENT_TYPE.CREATE_CHILD_SHIPMENT_SUCCESS',
  CREATE_CHILD_SHIPMENT_ERROR: 'SHIPMENT_TYPE.CREATE_CHILD_SHIPMENT_ERROR',

  SEND_APPROVAL_REQUEST_PROGRESS: 'SHIPMENT_TYPE.SEND_APPROVAL_REQUEST_PROGRESS',
  SEND_APPROVAL_REQUEST_SUCCESS: 'SHIPMENT_TYPE.SEND_APPROVAL_REQUEST_SUCCESS',
  SEND_APPROVAL_REQUEST_ERROR: 'SHIPMENT_TYPE.SEND_APPROVAL_REQUEST_ERROR',
  SET_APPROVERS_LIST: 'SHIPMENT_TYPE.SET_APPROVERS_LIST',

  DOCUMENT_UPLOAD_LIST: 'SHIPMENT_TYPE.DOCUMENT_UPLOAD_LIST',
  SET_SHIPMENT_BY_KEY: 'SHIPMENT_TYPE.SET_SHIPMENT_BY_KEY',

  ASSIGN_CARRIER_PROGRESS: 'SHIPMENT_TYPE.ASSIGN_CARRIER_PROGRESS',
  ASSIGN_CARRIER_SUCCESS: 'SHIPMENT_TYPE.ASSIGN_CARRIER_SUCCESS',
  ASSIGN_CARRIER_ERROR: 'SHIPMENT_TYPE.ASSIGN_CARRIER_ERROR',

  ADD_RATE_ENTRY_PROGRESS: 'SHIPMENT_TYPE.ADD_RATE_ENTRY_PROGRESS',
  ADD_RATE_ENTRY_SUCCESS: 'SHIPMENT_TYPE.ADD_RATE_ENTRY_SUCCESS',
  ADD_RATE_ENTRY_ERROR: 'SHIPMENT_TYPE.ADD_RATE_ENTRY_ERROR',

  VALIDATE_RATE_ENTRY_PROGRESS: 'SHIPMENT_TYPE.VALIDATE_RATE_ENTRY_PROGRESS',
  VALIDATE_RATE_ENTRY_SUCCESS: 'SHIPMENT_TYPE.VALIDATE_RATE_ENTRY_SUCCESS',
  VALIDATE_RATE_ENTRY_ERROR: 'SHIPMENT_TYPE.VALIDATE_RATE_ENTRY_ERROR',

  REMOVE_RATE_ENTRY_PROGRESS: 'SHIPMENT_TYPE.REMOVE_RATE_ENTRY_PROGRESS',
  REMOVE_RATE_ENTRY_SUCCESS: 'SHIPMENT_TYPE.REMOVE_RATE_ENTRY_SUCCESS',
  REMOVE_RATE_ENTRY_ERROR: 'SHIPMENT_TYPE.REMOVE_RATE_ENTRY_ERROR',

  GET_MASTER_CHILD_SHIPMENT_DETAILS_PROGRESS: 'SHIPMENT_TYPE.GET_MASTER_CHILD_SHIPMENT_DETAILS_PROGRESS',
  GET_MASTER_CHILD_SHIPMENT_DETAILS_SUCCESS: 'SHIPMENT_TYPE.GET_MASTER_CHILD_SHIPMENT_DETAILS_SUCCESS',
  GET_MASTER_CHILD_SHIPMENT_DETAILS_ERROR: 'SHIPMENT_TYPE.GET_MASTER_CHILD_SHIPMENT_DETAILS_ERROR',

  UPDATE_RATE_ENTRY_PROGRESS: 'SHIPMENT_TYPE.UPDATE_RATE_ENTRY_PROGRESS',
  UPDATE_RATE_ENTRY_SUCCESS: 'SHIPMENT_TYPE.UPDATE_RATE_ENTRY_SUCCESS',
  UPDATE_RATE_ENTRY_ERROR: 'SHIPMENT_TYPE.UPDATE_RATE_ENTRY_ERROR',

  CONVERT_PARTIAL_TO_SHIPMENT_PROGRESS: 'SHIPMENT_TYPE.CONVERT_PARTIAL_TO_SHIPMENT_PROGRESS',
  CONVERT_PARTIAL_TO_SHIPMENT_SUCCESS: 'SHIPMENT_TYPE.CONVERT_PARTIAL_TO_SHIPMENT_SUCCESS',
  CONVERT_PARTIAL_TO_SHIPMENT_ERROR: 'SHIPMENT_TYPE.CONVERT_PARTIAL_TO_SHIPMENT_ERROR',

  GET_SHIPMENT_BRANCH_ADDRESS_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENT_BRANCH_ADDRESS_PROGRESS',
  GET_SHIPMENT_BRANCH_ADDRESS_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENT_BRANCH_ADDRESS_SUCCESS',
  GET_SHIPMENT_BRANCH_ADDRESS_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENT_BRANCH_ADDRESS_ERROR',

  GET_SHIPMENTS_STOPS_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENTS_STOPS_PROGRESS',
  GET_SHIPMENTS_STOPS_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENTS_STOPS_SUCCESS',
  GET_SHIPMENTS_STOPS_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENTS_STOPS_ERROR',

  GET_PARCEL_EXPRESS_DASHBOARD_DATA_PROGRESS: 'SHIPMENT_TYPE.GET_PARCEL_EXPRESS_DASHBOARD_DATA_PROGRESS',
  GET_PARCEL_EXPRESS_DASHBOARD_DATA_SUCCESS: 'SHIPMENT_TYPE.GET_PARCEL_EXPRESS_DASHBOARD_DATA_SUCCESS',
  GET_PARCEL_EXPRESS_DASHBOARD_DATA_ERROR: 'SHIPMENT_TYPE.GET_PARCEL_EXPRESS_DASHBOARD_DATA_ERROR',

  SET_SHIPMENT_SEARCH_VIEW_TYPE: 'SHIPMENT_TYPE.SET_SHIPMENT_SEARCH_VIEW_TYPE',
  SET_SHIPMENT_SEARCH_VIEW_TYPE_INITIAL: 'SHIPMENT_TYPE.SET_SHIPMENT_SEARCH_VIEW_TYPE_INITIAL',
  SET_SHIPMENT_PRODUCT_VIEW_TYPE: 'SHIPMENT_TYPE.SET_SHIPMENT_PRODUCT_VIEW_TYPE',
  SET_SHIPMENT_PRODUCT_VIEW_TYPE_INITIAL: 'SHIPMENT_TYPE.SET_SHIPMENT_PRODUCT_VIEW_TYPE_INITIAL',

  GET_TABLE_VIEW_COLUMNS_PROGRESS: 'SHIPMENT_TYPE.GET_TABLE_VIEW_COLUMNS_PROGRESS',
  GET_TABLE_VIEW_COLUMNS_SUCCESS: 'SHIPMENT_TYPE.GET_TABLE_VIEW_COLUMNS_SUCCESS',
  GET_TABLE_VIEW_COLUMNS_ERROR: 'SHIPMENT_TYPE.GET_TABLE_VIEW_COLUMNS_ERROR',

  SAVE_TABLE_VIEW_COLUMNS_PROGRESS: 'SHIPMENT_TYPE.SAVE_TABLE_VIEW_COLUMNS_PROGRESS',
  SAVE_TABLE_VIEW_COLUMNS_SUCCESS: 'SHIPMENT_TYPE.SAVE_TABLE_VIEW_COLUMNS_SUCCESS',
  SAVE_TABLE_VIEW_COLUMNS_ERROR: 'SHIPMENT_TYPE.SAVE_TABLE_VIEW_COLUMNS_ERROR',

  GET_SHIPMENT_PRODUCT_LIST_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENT_PRODUCT_LIST_PROGRESS',
  GET_SHIPMENT_PRODUCT_LIST_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENT_PRODUCT_LIST_SUCCESS',
  GET_SHIPMENT_PRODUCT_LIST_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENT_PRODUCT_LIST_ERROR',

  GET_SHIPMENT_PRODUCT_FULL_LIST_PROGRESS: 'SHIPMENT_TYPE.GET_SHIPMENT_PRODUCT_FULL_LIST_PROGRESS',
  GET_SHIPMENT_PRODUCT_FULL_LIST_SUCCESS: 'SHIPMENT_TYPE.GET_SHIPMENT_PRODUCT_FULL_LIST_SUCCESS',
  GET_SHIPMENT_PRODUCT_FULL_LIST_ERROR: 'SHIPMENT_TYPE.GET_SHIPMENT_PRODUCT_FULL_LIST_ERROR',

  UPDATE_PRODUCT_LIST_PARTIAL_PROGRESS: 'SHIPMENT_TYPE.UPDATE_PRODUCT_LIST_PARTIAL_PROGRESS',
  UPDATE_PRODUCT_LIST_PARTIAL_SUCCESS: 'SHIPMENT_TYPE.UPDATE_PRODUCT_LIST_PARTIAL_SUCCESS',
  UPDATE_PRODUCT_LIST_PARTIAL_ERROR: 'SHIPMENT_TYPE.UPDATE_PRODUCT_LIST_PARTIAL_ERROR',

  UPDATE_FREIGHT_CLASS_PROGRESS: 'SHIPMENT_TYPE.UPDATE_FREIGHT_CLASS_PROGRESS',
  UPDATE_FREIGHT_CLASS_SUCCESS: 'SHIPMENT_TYPE.UPDATE_FREIGHT_CLASS_SUCCESS',
  UPDATE_FREIGHT_CLASS_ERROR: 'SHIPMENT_TYPE.UPDATE_FREIGHT_CLASS_ERROR',

  UPDATE_SINGLE_PRODUCT_BY_INDEX: 'SHIPMENT_TYPE.UPDATE_SINGLE_PRODUCT_BY_INDEX',

  UPDATE_BOL_CARRIER_PROGRESS: 'SHIPMENT_TYPE.UPDATE_BOL_CARRIER_PROGRESS',
  UPDATE_BOL_CARRIER_SUCCESS: 'SHIPMENT_TYPE.UPDATE_BOL_CARRIER_SUCCESS',
  UPDATE_BOL_CARRIER_ERROR: 'SHIPMENT_TYPE.UPDATE_BOL_CARRIER_ERROR',

  GET_ADVANCED_PLANNING_EMAILS_PROGRESS: 'SHIPMENT_TYPE.GET_ADVANCED_PLANNING_EMAILS_PROGRESS',
  GET_ADVANCED_PLANNING_EMAILS_SUCCESS: 'SHIPMENT_TYPE.GET_ADVANCED_PLANNING_EMAILS_SUCCESS',
  GET_ADVANCED_PLANNING_EMAILS_ERROR: 'SHIPMENT_TYPE.GET_ADVANCED_PLANNING_EMAILS_ERROR',

  SEND_ADVANCED_PLANNING_EMAIL_PROGRESS: 'SHIPMENT_TYPE.SEND_ADVANCED_PLANNING_EMAIL_PROGRESS',
  SEND_ADVANCED_PLANNING_EMAIL_SUCCESS: 'SHIPMENT_TYPE.SEND_ADVANCED_PLANNING_EMAIL_SUCCESS',
  SEND_ADVANCED_PLANNING_EMAIL_ERROR: 'SHIPMENT_TYPE.SEND_ADVANCED_PLANNING_EMAIL_ERROR',

  RESET_SHIPMENT_EDIT_DETAILS: 'SHIPMENT_TYPE.RESET_SHIPMENT_EDIT_DETAILS',

  SET_PO_TABLE_COLUMN: 'SHIPMENT_TYPE.SET_PO_TABLE_COLUMN',
  SET_EDIT_SHIPMENT_RATESHOP_MODAL: 'SHIPMENT_TYPE.SET_EDIT_SHIPMENT_RATESHOP_MODAL',

  SET_SELECTED_RATE_SHOP_INDEX: 'SHIPMENT_TYPE.SET_SELECTED_RATE_SHOP_INDEX',

  SET_SHIPMENT_VENDOR_DATA: 'SHIPMENT_TYPE.SET_SHIPMENT_VENDOR_DATA',

  GET_SEARCH_QUOTE_LIST_PROGRESS: 'SHIPMENT_TYPE.GET_SEARCH_QUOTE_LIST_PROGRESS',

  GET_SEARCH_QUOTE_LIST_SUCCESS: 'SHIPMENT_TYPE.GET_SEARCH_QUOTE_LIST_SUCCESS',

  GET_SEARCH_QUOTE_LIST_ERROR: 'SHIPMENT_TYPE.GET_SEARCH_QUOTE_LIST_ERROR',

  SET_SEARCH_QUOTE_LIST: 'SHIPMENT_TYPE.SET_SEARCH_QUOTE_LIST',

  REFRESH_SHIPMENT_DETAILS: 'SHIPMENT_TYPE.REFRESH_SHIPMENT_DETAILS',

  SET_BRANCH_ACC_NUMBER: 'SET_BRANCH_ACC_NUMBER',
  GET_SPOT_QUOTE_BIDDERS_PROGRESS: 'SHIPMENT_TYPE.GET_SPOT_QUOTE_BIDDERS_PROGRESS',
  GET_SPOT_QUOTE_BIDDERS_SUCCESS: 'SHIPMENT_TYPE.GET_SPOT_QUOTE_BIDDERS_SUCCESS',
  GET_SPOT_QUOTE_BIDDERS_ERROR: 'SHIPMENT_TYPE.GET_SPOT_QUOTE_BIDDERS_ERROR',

  SEARCH_SPOT_QUOTE_BIDDERS_PROGRESS: 'SHIPMENT_TYPE.SEARCH_SPOT_QUOTE_BIDDERS_PROGRESS',
  SEARCH_SPOT_QUOTE_BIDDERS_SUCCESS: 'SHIPMENT_TYPE.SEARCH_SPOT_QUOTE_BIDDERS_SUCCESS',
  SEARCH_SPOT_QUOTE_BIDDERS_ERROR: 'SHIPMENT_TYPE.SEARCH_SPOT_QUOTE_BIDDERS_ERROR',
  RESET_SEARCH_QUOTE_BIDDERS: 'SHIPMENT_TYPE.RESET_SEARCH_QUOTE_BIDDERS',

  ADD_SPOT_QUOTE_BIDDERS_PROGRESS: 'SHIPMENT_TYPE.ADD_SPOT_QUOTE_BIDDERS_PROGRESS',
  ADD_SPOT_QUOTE_BIDDERS_SUCCESS: 'SHIPMENT_TYPE.ADD_SPOT_QUOTE_BIDDERS_SUCCESS',
  ADD_SPOT_QUOTE_BIDDERS_ERROR: 'SHIPMENT_TYPE.ADD_SPOT_QUOTE_BIDDERS_ERROR',

  DELETE_SPOT_QUOTE_BIDDERS_PROGRESS: 'SHIPMENT_TYPE.DELETE_SPOT_QUOTE_BIDDERS_PROGRESS',
  DELETE_SPOT_QUOTE_BIDDERS_SUCCESS: 'SHIPMENT_TYPE.DELETE_SPOT_QUOTE_BIDDERS_SUCCESS',
  DELETE_SPOT_QUOTE_BIDDERS_ERROR: 'SHIPMENT_TYPE.DELETE_SPOT_QUOTE_BIDDERS_ERROR',

  GET_SPOT_QUOTE_COLLABORATORS_PROGRESS: 'SHIPMENT_TYPE.GET_SPOT_QUOTE_COLLABORATORS_PROGRESS',
  GET_SPOT_QUOTE_COLLABORATORS_SUCCESS: 'SHIPMENT_TYPE.GET_SPOT_QUOTE_COLLABORATORS_SUCCESS',
  GET_SPOT_QUOTE_COLLABORATORS_ERROR: 'SHIPMENT_TYPE.GET_SPOT_QUOTE_COLLABORATORS_ERROR',

  ADD_SPOT_QUOTE_COLLABORATORS_PROGRESS: 'SHIPMENT_TYPE.ADD_SPOT_QUOTE_COLLABORATORS_PROGRESS',
  ADD_SPOT_QUOTE_COLLABORATORS_SUCCESS: 'SHIPMENT_TYPE.ADD_SPOT_QUOTE_COLLABORATORS_SUCCESS',
  ADD_SPOT_QUOTE_COLLABORATORS_ERROR: 'SHIPMENT_TYPE.ADD_SPOT_QUOTE_COLLABORATORS_ERROR',

  DELETE_SPOT_QUOTE_COLLABORATORS_PROGRESS: 'SHIPMENT_TYPE.DELETE_SPOT_QUOTE_COLLABORATORS_PROGRESS',
  DELETE_SPOT_QUOTE_COLLABORATORS_SUCCESS: 'SHIPMENT_TYPE.DELETE_SPOT_QUOTE_COLLABORATORS_SUCCESS',
  DELETE_SPOT_QUOTE_COLLABORATORS_ERROR: 'SHIPMENT_TYPE.DELETE_SPOT_QUOTE_COLLABORATORS_ERROR',

  AWARD_SPOT_QUOTE_BIDDERS_PROGRESS: 'SHIPMENT_TYPE.AWARD_SPOT_QUOTE_BIDDERS_PROGRESS',
  AWARD_SPOT_QUOTE_BIDDERS_SUCCESS: 'SHIPMENT_TYPE.AWARD_SPOT_QUOTE_BIDDERS_SUCCESS',
  AWARD_SPOT_QUOTE_BIDDERS_ERROR: 'SHIPMENT_TYPE.AWARD_SPOT_QUOTE_BIDDERS_ERROR',
  AWARD_BID: 'SHIPMENT_TYPE.AWARD_BID',
  CLEAR_SHIPMENT_DETAILS: 'SHIPMENT_TYPE.CLEAR_SHIPMENT_DETAILS',

  DELETE_SHIPMENT_TENDER_PROGRESS: 'SHIPMENT_TYPE.DELETE_SHIPMENT_TENDER_PROGRESS',
  DELETE_SHIPMENT_TENDER_SUCCESS: 'SHIPMENT_TYPE.DELETE_SHIPMENT_TENDER_SUCCESS',
  DELETE_SHIPMENT_TENDER_ERROR: 'SHIPMENT_TYPE.DELETE_SHIPMENT_TENDER_ERROR',

  GET_CARGO_SPECIFIC_ACCESSORIALS_PROGRESS: 'SHIPMENT_TYPE.GET_CARGO_SPECIFIC_ACCESSORIALS_PROGRESS',
  GET_CARGO_SPECIFIC_ACCESSORIALS_SUCCESS: 'SHIPMENT_TYPE.GET_CARGO_SPECIFIC_ACCESSORIALS_SUCCESS',
  GET_CARGO_SPECIFIC_ACCESSORIALS_ERROR: 'SHIPMENT_TYPE.GET_CARGO_SPECIFIC_ACCESSORIALS_ERROR',
};

export default ShipmentTypes;
